// Legacy bundle loaded after jQuery global setup
import "jquery-ui-dist/jquery-ui"

// Legacy Imports
import "./legacy/plugins/underscore.min"
import "./legacy/ace_theme/bootstrap"
import "./legacy/ace_theme/chosen.jquery"
import "./legacy/chosen/init_chosen"

// Data Tables
import "./legacy/ace_theme/data_tables/jquery.dataTables.min"

import "./legacy/plugins/jquery.elastic.source"

// ACE Theme
import "./legacy/ace_theme/pace"
import bootbox from "./legacy/ace_theme/bootbox"
window.bootbox = bootbox
import "./legacy/ace_theme/ace_checkbox"
import "./legacy/ace_theme/ace-extra"
import "./legacy/ace_theme/ace-elements"
import "./legacy/ace_theme/ace"

// Editable
import "./legacy/ace_theme/x-editable/bootstrap-editable"
import "./legacy/ace_theme/x-editable/ace-editable"

import "./legacy/ace_theme/jquery.gritter"

// ACE Theme - Recursive imports
import "./legacy/ace_theme/ace/ace"
import "./legacy/ace_theme/ace/ace.ajax-content"
import "./legacy/ace_theme/ace/ace.auto-container"
import "./legacy/ace_theme/ace/ace.auto-padding"
import "./legacy/ace_theme/ace/ace.onpage-help"
import "./legacy/ace_theme/ace/ace.searchbox-autocomplete"
import "./legacy/ace_theme/ace/ace.settings-rtl"
import "./legacy/ace_theme/ace/ace.settings-skin"
import "./legacy/ace_theme/ace/ace.settings"
import "./legacy/ace_theme/ace/ace.sidebar-scroll-1"
import "./legacy/ace_theme/ace/ace.sidebar-scroll-2"
import "./legacy/ace_theme/ace/ace.sidebar"
import "./legacy/ace_theme/ace/ace.submenu-hover"
import "./legacy/ace_theme/ace/ace.touch-drag"
import "./legacy/ace_theme/ace/ace.widget-box"
import "./legacy/ace_theme/ace/ace.widget-on-reload"
import "./legacy/ace_theme/ace/elements.aside"
import "./legacy/ace_theme/ace/elements.colorpicker"
import "./legacy/ace_theme/ace/elements.fileinput"
import "./legacy/ace_theme/ace/elements.onpage-help"
import "./legacy/ace_theme/ace/elements.scroller"
import "./legacy/ace_theme/ace/elements.spinner"
import "./legacy/ace_theme/ace/elements.treeview"
import "./legacy/ace_theme/ace/elements.typeahead"
import "./legacy/ace_theme/ace/elements.wizard"
import "./legacy/ace_theme/ace/elements.wysiwyg"

import "./legacy/ace_theme/flot/jquery.flot"
import "./legacy/ace_theme/jquery.colorbox"
import "./legacy/ace_theme/jquery.maskedinput"

// Backend
import "./legacy/backend/avatar"
import "./legacy/coocon"
import "./legacy/backend/cocoon_operators"
import "./legacy/backend/company"
import "./legacy/backend/download_chart"
import "./legacy/backend/image_gallery"
import "./legacy/backend/language"
import "./legacy/backend/modal_login"
import "./legacy/backend/route"
import "./legacy/backend/tag"
import "./legacy/backend/tooltip"

import "./legacy/datatables/init_datatables"
import "./legacy/gmaps4rails/map"

import "./legacy/custom_alert"
import "./legacy/init"
